import { TemplateRef } from '@angular/core';

export interface Overlay<T> {
    hideBackdrop?: boolean;
    hidePointerEvents?: boolean;
    backdropColor?: string;
    template?: TemplateRef<T>;
    component?: T;
    lazyTemplate?: string;
    context?: Context;
    classes?: string;
}

export interface ComponentOverlay<T> {
    hideBackdrop?: boolean;
    backdropColor?: string;
    hidePointerEvents?: boolean;
    component: T;
    context?: Context;
    classes?: string;
}

export interface Context {
    $implicit?: any;
    [key: string]: any;
}

export function OverlayEvent(detail: Overlay<unknown> | null) {
    window.dispatchEvent(new CustomEvent('overlay', { detail }));
}


